import React from 'react';
import Grid from './components/Grid';

function App() {
  return (
    <div className="app-container">
      <Grid />
    </div>
  );
}

export default App;
